'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Request = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactHttpRequest = require('react-http-request');

var _reactHttpRequest2 = _interopRequireDefault(_reactHttpRequest);

var _Loading = require('./Presentational components/Pages/Loading/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _Error = require('./Presentational components/Pages/Error/Error');

var _Error2 = _interopRequireDefault(_Error);

var _Success = require('./Presentational components/Pages/Success/Success');

var _Success2 = _interopRequireDefault(_Success);

var _Forbidden = require('./Presentational components/Pages/Forbidden/Forbidden');

var _Forbidden2 = _interopRequireDefault(_Forbidden);

var _NotAuthorized = require('./Presentational components/Pages/NotAuthorized/NotAuthorized');

var _NotAuthorized2 = _interopRequireDefault(_NotAuthorized);

var _Error3 = require('./Presentational components/SnackBars/Error/Error');

var _Error4 = _interopRequireDefault(_Error3);

var _Success3 = require('./Presentational components/SnackBars/Success/Success');

var _Success4 = _interopRequireDefault(_Success3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Request = exports.Request = function (_React$Component) {
  _inherits(Request, _React$Component);

  function Request() {
    _classCallCheck(this, Request);

    return _possibleConstructorReturn(this, (Request.__proto__ || Object.getPrototypeOf(Request)).apply(this, arguments));
  }

  _createClass(Request, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          url = _props.url,
          others = _objectWithoutProperties(_props, ['children', 'url']);

      return _react2.default.createElement(
        _reactHttpRequest2.default,
        _extends({ url: process.env.baseURL + url }, others),
        function (_ref) {
          var error = _ref.error,
              result = _ref.result,
              loading = _ref.loading;

          if (loading) {
            return _react2.default.createElement(_Loading2.default, null);
          } else if (error && error.status === 401) {
            setTimeout(function () {
              if (process.env.auth.provider !== 'ActiveDirectory') {
                window.location = 'login';
              }
            }, 2000);
            return _react2.default.createElement(_NotAuthorized2.default, null);
          } else if (error && error.status === 403) {
            return _react2.default.createElement(_Forbidden2.default, null);
          } else if (error) {
            return _react2.default.createElement(_Error2.default, null);
          } else {
            return children(result);
          }
        }
      );
    }
  }]);

  return Request;
}(_react2.default.Component);

Request.propTypes = {
  children: _react2.default.PropTypes.func.isRequired
};

var _class = function (_React$Component2) {
  _inherits(_class, _React$Component2);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this2 = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this2.state = _react2.default.createElement(_Loading2.default, null);
    _this2.getComponent = _this2.getComponent.bind(_this2);
    return _this2;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var dispatch = this.context.store.dispatch;

      var catchFunction = function catchFunction(error) {
        if (_this3.props.onError) {
          _this3.setState(_this3.props.onError(error, dispatch, _this3.props));
        }

        if (error.status === 401) {
          setTimeout(function () {
            if (process.env.auth.provider !== 'ActiveDirectory') {
              window.location = 'login';
            }
          }, 2500);
          _this3.setState(_react2.default.createElement(_NotAuthorized2.default, null));
        } else if (error.status === 403) {
          _this3.setState(_react2.default.createElement(_Forbidden2.default, null));
        } else {
          var component = void 0;
          if (_this3.props.snackbar) {
            component = _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_Error4.default, null),
              _this3.props.template || _react2.default.createElement(_Error2.default, { onlyIcon: true })
            );
          } else {
            component = _react2.default.createElement(_Error2.default, null);
          }
          _this3.setState(component);
        }
      };
      var thenFunction = function thenFunction(result) {
        var component = void 0;
        if (_this3.props.onSuccess) {
          component = _this3.props.onSuccess(result, dispatch, _this3.props, _this3.context.store.getState());
        }
        if (_this3.props.snackbar && !component) {
          component = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Success4.default, null),
            _this3.props.template || _react2.default.createElement(_Success2.default, { onlyIcon: true })
          );
        } else if (!component) {
          component = _react2.default.createElement(_Success2.default, null);
        }
        _this3.setState(component);
      };
      var request = this.props.request;

      if (Object.prototype.toString.call(request) === '[object Array]') {
        var promises = [];
        for (var i = 0; i < request.length; i++) {
          promises.push(request[i]());
        }
        _bluebird2.default.all(promises).then(thenFunction).catch(catchFunction);
      } else {
        request().then(thenFunction).catch(catchFunction);
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      var Component = this.state || _react2.default.createElement('div', null);
      var props = this.props || {};
      return _react2.default.cloneElement(Component, props);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.getComponent();
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  request: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.func, _react2.default.PropTypes.array]).isRequired,
  onSuccess: _react2.default.PropTypes.func,
  onError: _react2.default.PropTypes.func,
  snackbar: _react2.default.PropTypes.bool,
  template: _react2.default.PropTypes.any
};
_class.contextTypes = {
  store: _react2.default.PropTypes.object.isRequired
};
_class.defaultProps = {
  snackbar: true
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Request.js
 ** module id = 114
 ** module chunks = 0
 **/